import { useRef, useState } from "react";
import { UploadCloud } from "lucide-react";
import { ACCEPT, MAX_FILE_MB } from "@/lib/files";
import { cn } from "@/lib/utils";

export function UploadDropzone({ onFiles }) {
  const inputRef = useRef(null);
  const [over, setOver] = useState(false);
  const drop = (e) => {
    e.preventDefault();
    setOver(false);
    if (e.dataTransfer?.files?.length) onFiles(e.dataTransfer.files);
  };
  return (
    <div
      onDragOver={(e) => {
        e.preventDefault();
        setOver(true);
      }}
      onDragLeave={() => setOver(false)}
      onDrop={drop}
      className={cn("flex flex-col items-center justify-center rounded-2xl border border-dashed px-6 py-8 text-center transition-colors", over ? "border-white/40 bg-white/[0.04]" : "border-white/[0.12] bg-ink-900")}
      data-testid="files-dropzone"
    >
      <UploadCloud className="h-6 w-6 text-zinc-500" strokeWidth={1.5} />
      <p className="mt-3 text-sm text-zinc-300">
        Drop files here or{" "}
        <button type="button" onClick={() => inputRef.current?.click()} className="text-white underline underline-offset-4" data-testid="files-dropzone-browse">
          browse
        </button>
      </p>
      <p className="mt-1 text-xs text-zinc-600">PDF, Word, PowerPoint, Excel, CSV, text, Markdown and images · up to {MAX_FILE_MB} MB</p>
      <input
        ref={inputRef}
        type="file"
        multiple
        accept={ACCEPT}
        className="hidden"
        data-testid="files-upload-input"
        onChange={(e) => {
          onFiles(e.target.files);
          e.target.value = "";
        }}
      />
    </div>
  );
}
